import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import { BodyBold } from 'ggx-componentlibrary/design/typography/typography.styles'
import { RadioButtonGroup } from 'ggx-componentlibrary/components/radio-button/radio-button.component'
import {
  RadioButton,
  RadioButtonWrapper,
} from 'ggx-componentlibrary/components/radio-button/radio-button.component.styles'
import styled from 'styled-components'
import {
  FONT_SIZE,
  LINE_HEIGHT,
} from 'ggx-componentlibrary/design/typography/typography.constants'
import { requiredField } from 'ggx-service/validation'
import { TextField } from 'ggx-componentlibrary/components/text-field/text-field.component'

const StyledRadioGroup = styled(RadioButtonGroup)`
  [role='radiogroup'] {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    row-gap: 16px;
  }

  [role='radio'] span {
    padding: 10px 14px;
    font-size: ${FONT_SIZE.MEDIUM};
    line-height: ${LINE_HEIGHT.MEDIUM};
    font-weight: 400;
  }
  [role='radio'][aria-checked='true'] span {
    font-weight: 700;
  }
`
const StyledTextField = styled(TextField)`
  flex: 1 0 100%;
  margin-top: -6px;
`
const PACKAGE_CONTENT = [
  'clothing_fabric',
  'accessories',
  'raw_materials',
  'household_goods',
  'stationery',
  'furniture',
  'electronics',
  'food',
  'plants_flowers',
  'medicine',
]
const PackageContentRadioGroup = props => {
  const [t] = useTranslation()
  const tContent = PACKAGE_CONTENT.map(item => t(`vn_contents__${item}`))
  const [showTextField, setShowTextField] = useState(
    props.input.value !== '' && !tContent.includes(props.input.value)
  )
  return (
    <StyledRadioGroup
      {...props}
      titleId="packet_content"
      value={props.input.value || ''}
      onSelectionChange={value => {
        value && setShowTextField(false)
        props.input.onChange(value)
      }}
    >
      {PACKAGE_CONTENT.map(item => (
        <RadioButton key={item} value={t(`vn_contents__${item}`)}>
          {t(`vn_contents__${item}`)}
        </RadioButton>
      ))}
      <RadioButtonWrapper aria-checked={showTextField}>
        <RadioButton onClick={() => setShowTextField(true)}>
          {t('vn_contents__others')}
        </RadioButton>
      </RadioButtonWrapper>
      {showTextField && (
        <StyledTextField
          value={props.input.value}
          input={props.input}
          meta={{ error: props.meta.error }}
          onChange={value => props.input.onChange(value)}
        />
      )}
    </StyledRadioGroup>
  )
}

const PackageContentForm = () => {
  const [t] = useTranslation()
  return (
    <div style={{ margin: '4px 0 32px' }}>
      <BodyBold style={{ marginBottom: '10px' }}>
        {t('select_transport_content')}
      </BodyBold>
      <Field
        name="order_request_extra_attributes.package_content"
        component={PackageContentRadioGroup}
        validate={text =>
          requiredField(t('error__select_transport_content'))(text || '') ||
          (text.length > 250 && t('error.characterLimit250')) ||
          (text === 'others' ? t('error__enter_transport_content') : undefined)
        }
      />
    </div>
  )
}

export { PackageContentForm }
